// ARQUIVO ATUALIZADO E CORRIGIDO
import React, { useState, useRef } from 'react';
import useClickOutside from '../../hooks/useClickOutside';
import { AddIcon, BellIcon, SearchIcon, MenuIcon } from '../ui/Icons';
// --- INÍCIO DA ALTERAÇÃO: Re-adicionando a importação do logo ---
import vflowLogo from '../../assets/vflow-logo.png'; 
// --- FIM DA ALTERAÇÃO ---

const Avatar = ({ user }) => {
    const getInitials = (email) => {
        if (!email) return '..';
        const parts = email.split('@')[0].split(/[._-]/);
        return parts.map(p => p[0]).slice(0, 2).join('').toUpperCase();
    };
    return (
        <div className="w-9 h-9 bg-indigo-500 rounded-full flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/50 overflow-hidden cursor-pointer">
            {user?.avatarUrl ? (
                <img src={user.avatarUrl} alt="User Avatar" className="w-full h-full object-cover" />
            ) : (
                <span className="text-sm font-semibold">{getInitials(user?.email)}</span>
            )}
        </div>
    );
};

const DropdownMenu = ({ trigger, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    useClickOutside(menuRef, () => setIsOpen(false));
    return (
        <div className="relative" ref={menuRef}>
            <div onClick={() => setIsOpen(p => !p)}>{trigger}</div>
            {isOpen && (
                <div 
                    onClick={() => setIsOpen(false)} 
                    className="absolute right-0 mt-2 bg-white dark:bg-gray-800/90 backdrop-blur-lg border border-gray-200 dark:border-white/10 rounded-lg shadow-xl py-1 animate-fade-in z-50"
                >
                    {children}
                </div>
            )}
        </div>
    );
};

const Navbar = ({ user, onLogout, onAddClick, onSettingsClick, onOpenPalette, onToggleSidebar, onOpenAvatarModal }) => {
    return (
        <header className="fixed top-0 left-0 right-0 bg-gray-100/80 dark:bg-gray-900/50 backdrop-blur-lg border-b border-gray-200 dark:border-white/10 text-gray-800 dark:text-white shadow-lg z-40 h-16">
            <div className="w-full h-full px-4 sm:px-6 lg:px-8 flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <button onClick={onToggleSidebar} className="p-2 rounded-full hover:bg-black/10 dark:hover:bg-white/10 transition-colors md:hidden">
                        <MenuIcon size={24} />
                    </button>
                    {/* --- INÍCIO DA ALTERAÇÃO: Re-adicionando a tag da imagem do logo --- */}
                    <img src={vflowLogo} alt="V-Flow Logo" className="h-8 hidden md:block" />
                    {/* --- FIM DA ALTERAÇÃO --- */}
                </div>
                
                <div className="flex-1 flex justify-center px-4">
                    <button onClick={onOpenPalette} className="hidden md:flex w-full max-w-md bg-gray-200 dark:bg-white/5 border border-gray-300 dark:border-white/10 rounded-full px-4 py-2 text-sm text-gray-500 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-white/10 transition-colors items-center justify-between">
                        <span>Pesquisar...</span>
                        <span className="text-xs border border-gray-400 dark:border-gray-500 rounded-md px-1.5 py-0.5">⌘K</span>
                    </button>
                    <button onClick={onOpenPalette} aria-label="Pesquisar" className="md:hidden p-2 rounded-full bg-black/10 dark:bg-white/10 hover:bg-black/20 dark:hover:bg-white/20 transition-colors">
                        <SearchIcon size={20}/>
                    </button>
                </div>

                <div className="flex items-center space-x-2 sm:space-x-4">
                    <DropdownMenu trigger={
                        <button aria-label="Adicionar novo item" className="p-2 rounded-full bg-black/10 dark:bg-white/10 hover:bg-black/20 dark:hover:bg-white/20 transition-colors">
                            <AddIcon size={20} />
                        </button>
                    }>
                        <div className="w-48 text-gray-800 dark:text-white">
                            <a href="#" onClick={(e) => { e.preventDefault(); onAddClick(); }} className="block px-4 py-2 text-sm hover:bg-black/5 dark:hover:bg-white/10">Nova Tarefa</a>
                            <a href="#" onClick={(e) => { e.preventDefault(); onSettingsClick(); }} className="block px-4 py-2 text-sm hover:bg-black/5 dark:hover:bg-white/10">Configurações</a>
                        </div>
                    </DropdownMenu>

                    <DropdownMenu trigger={
                        <button aria-label="Notificações" className="relative p-2 rounded-full bg-black/10 dark:bg-white/10 hover:bg-black/20 dark:hover:bg-white/20 transition-colors">
                            <BellIcon size={20} />
                        </button>
                    }>
                         <div className="w-80"><div className="px-4 py-3 text-sm text-gray-500 text-center">Nenhuma notificação</div></div>
                    </DropdownMenu>

                    <DropdownMenu trigger={<button aria-label="Menu do perfil"><Avatar user={user} /></button>}>
                        <div className="w-56 text-gray-800 dark:text-white">
                            <div className="px-4 py-2 border-b border-gray-200 dark:border-white/10">
                                <p className="text-sm">Logado como</p>
                                <p className="text-sm font-medium text-gray-600 dark:text-gray-300 truncate">{user?.username || user?.email}</p>
                            </div>
                            <button onClick={onOpenAvatarModal} className="block w-full text-left px-4 py-2 text-sm hover:bg-black/5 dark:hover:bg-white/10">Mudar Avatar</button>
                            <a href="#" onClick={(e) => { e.preventDefault(); onLogout(); }} className="block px-4 py-2 text-sm text-red-500 hover:bg-black/5 dark:hover:bg-white/10">Sair</a>
                        </div>
                    </DropdownMenu>
                </div>
            </div>
        </header>
    );
};

export default Navbar;